import React from 'react';
import { CheckIcon } from 'lucide-react';
const POSITIVE = /^(yes|y|true|x|✓|✔|included|available|full|unlimited)$/i;
const NEGATIVE = /^(no|n|false|-|–|—|none|n\/a|not included)$/i;
interface PricingValueProps {
  value: string;
  align?: 'center' | 'right';
}
export function PricingValue({
  value,
  align = 'center'
}: PricingValueProps) {
  if (POSITIVE.test(value)) {
    return <span className={`flex ${align === 'center' ? 'justify-center' : 'justify-end'}`} data-id="element-74" data-mp="270tcy6f2jkk7">
        <CheckIcon size={18} className="text-[#E9A165]" aria-label="Included" data-id="element-75" data-mp="2c05x2jek2dj3" />
      </span>;
  }
  if (value === '' || NEGATIVE.test(value)) {
    return <span className="text-zinc-700 text-base" aria-label="Not included" data-id="element-76" data-mp="1x8nm500jz96l">
        —
      </span>;
  }
  return <span className="text-sm text-white/80 leading-snug" data-id="element-77" data-mp="227i27u74yjn0">{value}</span>;
}